import React from 'react';
import classNames from 'classnames';
import './indexed-label.scss';

interface IndexedLabelProps {
	index: number;
	className?: string;
}

const IndexedLabel = ({ index, className }: IndexedLabelProps) => (
	<div className={classNames('indexed-label', className)} data-test-id={`label-${index}`}>
		{index}
	</div>
);

export default IndexedLabel;
